module.exports = __webpack_public_path__ + "img/img-cs.bc45a35b.png";